"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import CommonAnimationWrapper from "../animation/CommonAnimationWrapper";
import CommonAnimationOpacity from "../animation/CommonAnimationOpacity";
import DropsListItemDeleteDropModal from "@/components/drops/view/item/options/delete/DropsListItemDeleteDropModal";
interface WaveDropDeleteButtonProps {
  readonly drop: ApiDrop;
  readonly className?: string | undefined;
}
const WaveDropDeleteButton: React.FC<WaveDropDeleteButtonProps> = t0 => {
  const $ = _c(13);
  const {
    drop,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      e.stopPropagation();
      setIsDeleteModalOpen(true);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const onDeleteClick = t2;
  const t3 = className || "tw-py-3 tw-px-4 tw-bg-red/5 hover:tw-bg-red/10 tw-border tw-border-solid tw-border-red/20 hover:tw-border-red/30 tw-rounded-lg tw-text-red/70 hover:tw-text-red tw-transition-all tw-duration-300 tw-ease-out tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-xs";
  let t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" aria-hidden="true" stroke="currentColor" className="tw-flex-shrink-0 tw-w-4 tw-h-4"><path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" /></svg>;
    t5 = <span>Delete Drop</span>;
    $[1] = t4;
    $[2] = t5;
  } else {
    t4 = $[1];
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t3) {
    t6 = <button className={t3} onClick={onDeleteClick}>{t4}{t5}</button>;
    $[3] = t3;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== drop || $[6] !== isDeleteModalOpen) {
    t7 = isDeleteModalOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-50" elementRole="dialog" onClicked={_temp}><DropsListItemDeleteDropModal drop={drop} closeModal={() => setIsDeleteModalOpen(false)} onDropDeleted={_temp3} /></CommonAnimationOpacity>;
    $[5] = drop;
    $[6] = isDeleteModalOpen;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t7) {
    t8 = <CommonAnimationWrapper mode="sync" initial={true}>{t7}</CommonAnimationWrapper>;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t6 || $[11] !== t8) {
    t9 = <>{t6}{t8}</>;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};
export default WaveDropDeleteButton;
function _temp(e_0) {
  return e_0.stopPropagation();
}
function _temp2() {
  window.history.back();
}
function _temp3() {
  setTimeout(_temp2, 300);
}